import { useNavigate } from 'react-router-dom';

import { CustomLink } from '../../../../models/payment-links-custom';
import { fillStatesWithZeros } from '../../../../utils/states';
import { PLRoutes } from '../../enums/routes.enum';
import { CustomPLTable } from '../custom-pl-table';
import { CustomPaymentLinksTableProps } from './types';

const CustomPaymentLinksTable = ({
	allowedCustomAction = false,
	allowExport = false,
	columns,
	customFilter,
	data,
	filters,
	hasFilters = false,
	hasSearch = false,
	isLoading,
	onFilterChange,
	pagination,
	setPagination,
	stateList,
	titleTable,
	totalResults,
}: CustomPaymentLinksTableProps) => {
	const navigate = useNavigate();

	const handleRedirectAllPayments = () => {
		navigate(PLRoutes.ALL);
	};

	const handleExportAction = () => {
		return;
	};

	const handleDisabledRow = (data: CustomLink) => {
		const { status, sub_status } = data;
		return status === 'inactive' && sub_status === 'finalized';
	};

	return (
		<CustomPLTable<CustomLink>
			title={titleTable}
			data={data}
			disabledRow={handleDisabledRow}
			isLoading={!!isLoading}
			columns={columns}
			hasFilters={hasFilters}
			hasDateFilter={true}
			allowCustomaAction={allowedCustomAction}
			allowCustomFilter={customFilter !== undefined}
			customFilter={customFilter}
			customActionText="Ver Todos"
			customAction={() => handleRedirectAllPayments()}
			allowExport={allowExport}
			stateList={fillStatesWithZeros({ states: ['active', 'inactive'], stateList })}
			filters={filters}
			onFilterChange={onFilterChange}
			hasSearch={hasSearch}
			exportAction={handleExportAction}
			hasPagination={!!totalResults && totalResults > 0}
			totalResults={totalResults}
			pagination={pagination}
			setPagination={setPagination}
		/>
	);
};

export { CustomPaymentLinksTable };
